export default __webpack_public_path__ + "57204545d46ec1906434f57aef7278ab.png";